export const API = process.env.REACT_APP_API;
export const APIV2 = process.env.REACT_APP_API_V2;
export const MAIN_WEBSITE_BASE_URL = process.env.REACT_APP_MAIN_WEBSITE_BASE_URL;
export const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
export const IMGKIT_URL = process.env.REACT_APP_IMGKIT_URL;
export const FB_PIXEL_ID = process.env.REACT_APP_FB_PIXEL_ID;
export const GTM_ID = process.env.REACT_APP_GTM_ID;
